import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const handleServicesClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (location.pathname === '/') {
      const el = document.getElementById('services');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => {
        const el = document.getElementById('services');
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    }
    setIsMobileMenuOpen(false);
  };

  const handleFaqClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (location.pathname === '/') {
      const el = document.getElementById('faq-section');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => {
        const el = document.getElementById('faq-section');
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    }
    setIsMobileMenuOpen(false);
  };

  const handleCompanyClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (location.pathname === '/') {
      const el = document.getElementById('company-section');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => {
        const el = document.getElementById('company-section');
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    }
    setIsMobileMenuOpen(false);
  };

  const handleContactClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (location.pathname === '/') {
      const el = document.getElementById('contact-section');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => {
        const el = document.getElementById('contact-section');
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    }
    setIsMobileMenuOpen(false);
  };

  const navLinks = [
    { path: '/#hero-section', label: 'TOP', onClick: (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      if (location.pathname === '/') {
        const el = document.getElementById('hero-section');
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      } else {
        navigate('/');
        setTimeout(() => {
          const el = document.getElementById('hero-section');
          if (el) el.scrollIntoView({ behavior: 'smooth' });
        }, 300);
      }
      setIsMobileMenuOpen(false);
    }},
    { path: '/#services', label: 'サービス内容', onClick: handleServicesClick },
    { path: '/#company-section', label: '会社概要', onClick: handleCompanyClick },
    { path: '/#faq-section', label: 'よくある質問', onClick: handleFaqClick },
    { path: '/#contact-section', label: 'お問い合わせ', onClick: handleContactClick },
  ];

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white/95 backdrop-blur-md shadow-md' : 'bg-white/80 backdrop-blur-sm'
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-20">
            {/* Logo/Company Name */}
            <Link to="/" className="flex-shrink-0">
              <h1 className="text-xl lg:text-2xl font-bold text-[#1a1a2e]" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                株式会社おかやま工務店
              </h1>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-8">
              {navLinks.map((link) =>
                link.onClick ? (
                  <a
                    key={link.path}
                    href={link.path}
                    onClick={link.onClick}
                    className="text-sm font-medium transition-colors duration-200 whitespace-nowrap text-[#1a1a2e] hover:text-[#ff6b35] cursor-pointer"
                  >
                    {link.label}
                  </a>
                ) : (
                  <Link
                    key={link.path}
                    to={link.path}
                    className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                      location.pathname === link.path
                        ? 'text-[#ff6b35]'
                        : 'text-[#1a1a2e] hover:text-[#ff6b35]'
                    }`}
                  >
                    {link.label}
                  </Link>
                )
              )}
            </nav>

            {/* Contact Info */}
            <div className="hidden lg:flex flex-col items-end">
              <a
                href="tel:086-012-3456"
                className="text-xl font-bold text-[#1a1a2e] hover:text-[#ff6b35] transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-fill mr-2"></i>
                086-012-3456
              </a>
              <span className="text-xs text-gray-600 mt-1 whitespace-nowrap">営業時間 8:00〜17:00</span>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden w-10 h-10 flex items-center justify-center text-[#1a1a2e] hover:text-[#ff6b35] transition-colors cursor-pointer"
              aria-label="メニュー"
            >
              <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 z-40 lg:hidden transition-all duration-300 ${
          isMobileMenuOpen ? 'visible opacity-100' : 'invisible opacity-0'
        }`}
      >
        <div
          className="absolute inset-0 bg-black/50"
          onClick={() => setIsMobileMenuOpen(false)}
        ></div>
        <div
          className={`absolute top-20 left-0 right-0 bg-white shadow-lg transition-transform duration-300 ${
            isMobileMenuOpen ? 'translate-y-0' : '-translate-y-full'
          }`}
        >
          <nav className="flex flex-col py-4">
            {navLinks.map((link) =>
              link.onClick ? (
                <a
                  key={link.path}
                  href={link.path}
                  onClick={link.onClick}
                  className="px-6 py-4 text-base font-medium transition-colors text-[#1a1a2e] hover:bg-gray-50 cursor-pointer"
                >
                  {link.label}
                </a>
              ) : (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-6 py-4 text-base font-medium transition-colors ${
                    location.pathname === link.path
                      ? 'text-[#ff6b35] bg-orange-50'
                      : 'text-[#1a1a2e] hover:bg-gray-50'
                  }`}
                >
                  {link.label}
                </Link>
              )
            )}
            <div className="px-6 py-4 border-t border-gray-200 mt-2">
              <a
                href="tel:086-012-3456"
                className="flex items-center text-lg font-bold text-[#1a1a2e] hover:text-[#ff6b35] transition-colors"
              >
                <i className="ri-phone-fill mr-2"></i>
                086-012-3456
              </a>
              <span className="text-xs text-gray-600 mt-2 block">営業時間 8:00〜17:00</span>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Header;
